/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'
import { Field, Form, Formik } from 'formik'
import { SearchIcon } from '@heroicons/react/solid'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Button, Form as NXUIForm } from '@nexigendigital/nxui'
import { Meta } from 'models/app'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    searchKey: string,
    meta: Meta,
    setMeta: (meta: Meta) => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Search({ searchKey, meta, setMeta }: Props) {
    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                searchByKey: searchKey,
                searchByValue: ''
            }}
            onSubmit={({ searchByKey, searchByValue }, {
                resetForm,
                setSubmitting
            }) => {
                setMeta({ ...meta, search_by: { key: searchByKey, value: searchByValue } })
                setSubmitting(false)
                resetForm()
            }}
        >
            {() => (
                <FormWrapper>
                    <Field
                        name={'searchByValue'}
                        type={'text'}
                        prefixes={['www']}
                        component={NXUIForm.InputField}
                    />
                    <SearchButton type={'submit'}>
                        <SearchIcon />
                    </SearchButton>
                </FormWrapper>
            )}
        </Formik>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const SearchButton = styled(Button)`
    min-width: 88px;
    background-color: ${props => props.theme['primary--200']};
    border: none;
    margin: 0;

    &:hover {
        background-color: ${props => props.theme['primary--200']};
    }

    > svg {
        fill: ${props => props.theme['white--100']};
        width: 20px;
        height: 20px;
    }
`

const FormWrapper = styled(Form)`
    display: flex;
    gap: 10px;
`
